<template>
  <v-container class="text-center">
    <v-row align="center">
      <v-col>
        <v-card class="pa-8" outlined>
          <div class="mb-4">
            <v-icon color="error" size="60">mdi-lock</v-icon>
          </div>
          <h1 class="display-2 error--text">Error 403</h1>
          <p class="text-h5 mt-4">{{ $t('errorlist.forbidden') }}</p>
          <p class="mb-6">{{ $t('errorlist.forbidden-info') }}</p>

          <div v-if="isAdminUser" class="mt-6 pa-4 blue-grey lighten-5 rounded">
            <v-alert type="info" text>
              <strong>Admin Notice:</strong> As an admin user, you only have access to the Admin
              Panel for user management.
            </v-alert>
            <v-btn :to="{ name: 'AdminPanel' }" color="primary" class="mt-4">
              <v-icon left>mdi-account-cog</v-icon>
              Go to Admin Panel
            </v-btn>
          </div>

          <div v-else class="mt-4">
            <v-btn :to="{ name: 'Dashboard' }" color="primary" outlined class="mr-2">
              {{ $t('go-home') }}
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Page403',
  computed: {
    ...mapGetters(['roles']),
    isAdminUser() {
      try {
        const userRoles = this.roles || [];
        return userRoles.some(role => role === 'admin-manager' || role === 'admin_manager');
      } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
</style>
